import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SearchBar = ({ 
  searchQuery, 
  onSearchChange, 
  onSearchSubmit, 
  placeholder = "Search new arrivals..." 
}) => {
  const [localQuery, setLocalQuery] = useState(searchQuery || '');

  const handleInputChange = (e) => {
    const value = e?.target?.value;
    setLocalQuery(value);
    onSearchChange?.(value);
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSearchSubmit?.(localQuery);
  };

  const handleClear = () => {
    setLocalQuery('');
    onSearchChange?.('');
    onSearchSubmit?.('');
  };

  return (
    <form onSubmit={handleSubmit} className="relative w-full">
      <div className="relative">
        <Icon 
          name="Search" 
          size={16} 
          className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" 
        />
        <Input
          type="text"
          placeholder={placeholder}
          value={localQuery}
          onChange={handleInputChange}
          className="pl-10 pr-10"
        />
        {localQuery && (
          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={handleClear}
            className="absolute right-1 top-1/2 transform -translate-y-1/2 h-8 w-8"
          >
            <Icon name="X" size={14} />
          </Button>
        )}
      </div>
    </form>
  );
};

export default SearchBar;